import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TEXT_SIZES } from "../../../../../constants/inputValues";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import { qrTextSize } from "../../../../../redux/slices/qrTextSettings";

function FrameTextSize() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepThree.frame
  );
  const textSize = useSelector((state) => state.qrText.textSize);

  const dispatch = useDispatch();

  const handleCustomTextSize = (e) => {
    const value = Number(e.target.value);
    dispatch(qrTextSize(value));
  };

  return (
    <>
      <FloatingLabel label={lang[18]}>
        <Form.Select
          name="font"
          value={textSize}
          onChange={handleCustomTextSize}
        >
          <option value={-1}>auto</option>
          {TEXT_SIZES.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </Form.Select>
      </FloatingLabel>
    </>
  );
}

export default memo(FrameTextSize);
